import AdminLayout from "components/layouts/AdminLayout";
import { Button, Spin } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { convertToObjectKeyString } from "Utils/Common";
import { useIntl } from "react-intl";
import HousingCompanyTable from "./HousingCompanyTable";
import HousingCompanyService from "services/services/HousingCompanyService";
import AdministrationImportServices from "services/services/AdministrationImportServices";
import { message } from "antd";
import Cookies from "universal-cookie";
import UserService from "services/UserService";
import NewLoanModal from "components/newLoan/NewLoanModal";

const HousingCompanyLayout = () => {
  const cookies = new Cookies();
  const cookiesData = cookies.get("target-group-housingcompany");
  const intl = useIntl();
  const [data, setData] = useState<any>();
  const [searchData, setSearchData] = useState<any>({
    loan_data_name: "",
    loan_data_customername: "",
    loan_data_customerid: "",
    loan_data_agreement: "",
    loan_data_margin: "",
    loan_data_period: "",
    loan_data_priority: "",
    loan_data_bank_group: "",
    cust_data_city: "",
    status: "all",
    loan_data_date_diff: "",
    loan_data_credit_number: "",
    cust_data_manager_name: "",
    sort: "asc",
    sort_by: "",
    ...cookies.get("target-group-housingcompany"),
  });
  const [loading, setLoading] = useState<any>(false);
  const [pageData, setPageData] = useState<any>({ size: 10, page: 0 });
  const [totalPages, setTotalPages] = useState<any>(0);
  const [totalRecords, setTotalRecords] = useState<any>(0);
  const [sort, setSort] = useState<any>(cookiesData?.sort || false);
  const [createLoanOpen, setCreateLoanOpen] = useState<any>(false);
  //orginal code
  // useEffect(() => {
  //     getAllData();
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [searchData,pageData])
  //end orginal code

  useEffect(() => {
    setPageData((prev: { size: number; page: number }) => ({
      ...prev,
      page: 0,
    }));
  }, [searchData]);

  useEffect(() => {
    getAllData();
  }, [searchData, pageData]);

  const getAllData = async () => {
    try {
      let object: any = {};
      object.size = pageData?.size;
      object.page = pageData?.page;
      object.loan_data_customername = searchData?.loan_data_customername;
      object.loan_data_customerid = searchData?.loan_data_customerid;
      object.loan_data_agreement = searchData?.loan_data_agreement;
      object.loan_data_margin = searchData?.loan_data_margin;
      object.loan_data_period = searchData?.loan_data_period;
      object.loan_data_priority = searchData?.loan_data_priority;
      object.cust_data_city = searchData?.cust_data_city;
      object.loan_data_bank_group = searchData?.loan_data_bank_group;
      object.status = searchData?.status;
      object.loan_data_name = searchData?.loan_data_name;
      object.loan_data_date_diff = searchData?.loan_data_date_diff;
      object.loan_data_credit_number = searchData?.loan_data_credit_number;
      object.cust_data_manager_name = searchData?.cust_data_manager_name;
      object.next_reference_data_check =
        searchData?.next_reference_data_check || "";
      object.sort = sort ? "desc" : "asc";
      object.sort_by = searchData.sort_by;

      cookies.set("target-group-housingcompany", object, { path: "/" });

      setLoading(true);
      Object.keys(object).forEach(function (key: any) {
        if (!object[key]) {
          delete object[key];
        }
      });

      const getAllDataCall =
        await HousingCompanyService.getallhousingcompany(object);
      setData(getAllDataCall?.data?.data);
      setTotalPages(getAllDataCall?.data?.total_pages);
      setTotalRecords(getAllDataCall?.data?.total_records);
      setLoading(false);
    } catch (error) {}
  };

  const selectLoanData = async (formData: any) => {
    formData.created_by = UserService.getUserFullName();
    const getAllDataCall = await HousingCompanyService.saveTender(formData);
    if (getAllDataCall?.data?.code === 500) {
      message.error(
        intl.formatMessage({
          id: convertToObjectKeyString(getAllDataCall?.data?.msg),
        }),
      );
    } else if (getAllDataCall?.data?.code === 200) {
      message.success(
        intl.formatMessage({
          id: convertToObjectKeyString(getAllDataCall?.data?.msg),
        }),
      );
      getAllData();
    }
  };

  const finishDontTender = async (formData: any) => {
    formData.created_by = UserService.getUserFullName();
    const getAllDataCall = await HousingCompanyService.saveTender(formData);
    if (getAllDataCall?.data?.code === 500) {
      message.error(
        intl.formatMessage({
          id: convertToObjectKeyString(getAllDataCall?.data?.msg),
        }),
      );
    } else if (getAllDataCall?.data?.code === 200) {
      message.success(
        intl.formatMessage({
          id: convertToObjectKeyString(getAllDataCall?.data?.msg),
        }),
      );
      getAllData();
    }
  };

  const transformCustomer = (customerData: any) => {
    setLoading(true);
    let object: any = {};
    object.customer_id = customerData?.loan_data_customerid;
    object.zipcode = customerData?.CUST_DATA?.cust_data_zipcode;

    AdministrationImportServices.transformCustomer(object)
      .then((response: any) => {
        if (response?.data?.code === 200) {
          getAllData();
          message.success(
            intl.formatMessage({
              id: convertToObjectKeyString("data_transformed_successfully"),
            }),
          );
        } else if (response?.data?.code === 500) {
          message.error(
            intl.formatMessage({
              id: convertToObjectKeyString(response?.data?.msg),
            }),
          );
        }
        setLoading(false);
      })
      .catch((err: any) => {
        console.log(err.message);
        setLoading(false);
      });
  };

  return (
    <>
      <AdminLayout>
        <div className="ant-card ant-card-bordered cu-mb-10 w-100 text-left cu-tab-text d-flex mt-1">
          <Link to={`/`}>
            <h4 className="cu-m-0 cu-p-0">
              <button className="ant-btn cu-border-0 back-btn text-primary">
                <FaArrowLeft style={{ fontWeight: 900, fontSize: "28px" }} />
              </button>
              &nbsp;
              <button className="ant-btn cu-border-0 h4 pl-0 align-middle mb-0">
                {intl.formatMessage({
                  id: convertToObjectKeyString("target_group"),
                })}
              </button>
            </h4>
          </Link>
          <div className="ms-auto mb-1">
            {/* <Link to={`/new-loan`}>
                            <button className="btn btn-sm btn-light px-3 cu-btn-green">{intl.formatMessage({id: convertToObjectKeyString('create_new_loan')})}</button>
                            
                        </Link> */}
            <Button
              className="btn btn-sm btn-light px-3 cu-btn-green"
              onClick={() => {
                setCreateLoanOpen(true);
              }}
            >
              {intl.formatMessage({
                id: convertToObjectKeyString("create_new_loan"),
              })}
            </Button>
          </div>
          <div></div>
        </div>
        <Spin spinning={loading}>
          <div className="cu-table-border">
            <HousingCompanyTable
              data={data}
              setSearchData={setSearchData}
              searchData={searchData}
              selectLoanData={selectLoanData}
              finishDontTender={finishDontTender}
              setPageData={setPageData}
              pageData={pageData}
              totalPages={totalPages}
              sort={sort}
              setSort={setSort}
              totalRecords={totalRecords}
              transformCustomer={transformCustomer}
            />
          </div>
        </Spin>
      </AdminLayout>
      <NewLoanModal
        createLoanOpen={createLoanOpen}
        setCreateLoanOpen={setCreateLoanOpen}
        getAllTargetGroup={getAllData}
      />
    </>
  );
};
export default HousingCompanyLayout;
